<template>
  <a-form-model
      ref="targetForm"
      :model="form"
      :rules="rules"
      :label-col="{span: 8}"
      :wrapper-col="{span: 14}"
  >
    <a-row class="form-row">
      <a-col :md="18" :lg="18" :xl="18" :xxl="18">
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="护照号" prop="passportNumber">
              <a-input v-model="form.passportNumber" placeholder="例如 EB8195***"
                       :disabled="hasApplicationId()"/>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="姓名" prop="chineseName">
              <a-input v-model="form.chineseName" placeholder="例如 李心安"
                       :disabled="hasApplicationId()"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="姓(拼音)" prop="surname">
              <a-input v-model="form.surname" placeholder="例如 li" :disabled="hasApplicationId()"/>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="名(拼音)" prop="givenName">
              <a-input v-model="form.givenName" placeholder="例如 xinan" :disabled="hasApplicationId()"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="出生日期" prop="birthday">
              <a-date-picker style="width: 100%" v-model.trim="form.birthday" :disabled-date="afterNow"
                             value-format="YYYY-MM-DD" :disabled="hasApplicationId()"/>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="面试大使馆" prop="visaLocation">
              <a-select v-model="form.visaLocation" placeholder="请选择" :disabled="hasApplicationId()">
                <a-select-option value="CHINA, BEIJING">北京</a-select-option>
                <a-select-option value="CHINA, SHANGHAI">上海</a-select-option>
                <a-select-option value="CHINA, GUANGZHOU">广州</a-select-option>
                <a-select-option value="CHINA, SHENYANG">沈阳</a-select-option>
                <a-select-option value="CHINA, WUHAN">武汉</a-select-option>
                <a-select-option value="HONG KONG">香港</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="备注" prop="remark">
              <a-input v-model="form.remark" placeholder="例如 学生签证"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-col>
      <a-col :md="6" :lg="6" :xl="6" :xxl="6">
        <a-upload
            name="file"
            v-model="form.passportImgUrl"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="url.recognition"
            :data="{platform: 'baidu', template: 'passport'}"
            :headers="this.headersWithoutJson"
            :before-upload="beforeUpload"
            @change="handlePassportChange">
          <img v-if="form.passportImgUrl" :src="form.passportImgUrl" :style="{width: '15rem'}"/>
          <template v-else>
            <div style="position: relative">
              <img src="../../assets/card/passport.png" :style="{width: '15rem'}"/>
              <a-icon v-if="!passportImg.loading" type="plus-circle"
                      style="position: absolute; font-size: 2rem; top: 40%; left: 45%; color: #4a90e2"
                      theme="filled"/>
              <a-spin v-if="passportImg.loading" size="large"
                      style="position: absolute; top: 40%; left: 45%"></a-spin>
            </div>
          </template>
        </a-upload>
      </a-col>
    </a-row>
    <DetailCreateModal ref="detailCreateModal"></DetailCreateModal>
  </a-form-model>
</template>

<script>
import DetailCreateModal from "@/components/usDs/DetailCreateModal";
import moment from "moment";
import {HttpMixins} from "@/mixins/http-mixins";
import {ResponsiveMixins} from "@/mixins/responsive-mixins";

const pattern = {
  englishName: /^[A-Za-z]+$/,
  name: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
  chinese: /^([\u4E00-\u9FA5]+)$/,
  passportNumber: /^([A-Z]|[0-9]){5,17}$/,
}


export default {
  name: "CreateTable",
  components: {DetailCreateModal},
  mixins: [HttpMixins, ResponsiveMixins],
  data() {
    return {
      moment,
      form: {},
      passportImg: {
        loading: false,
      },
      rules: {
        passportNumber: [{required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'}],
        chineseName: [{required: true, pattern: pattern.chinese, message: '输入有误,中文'}],
        surname: [{required: true, pattern: pattern.name, message: '输入有误,a-z'}],
        givenName: [{required: true, pattern: pattern.name, message: '输入有误,a-z'}],
        birthday: [{required: true, message: '必填!'}],
        visaLocation: [{required: true, message: '必填!'}],
        remark: [{}]
      },
      url: {
        add: window._CONFIG['domainURL'] + "/power/usDs",
        recognition: window._CONFIG['domainURL'] + "/power/recognition",
        addWithApplication: window._CONFIG['domainURL'] + "/usDs/addWithApplication"
      }
    }
  },
  methods: {
    hasApplicationId() {
      return this.form.applicationId ? true : false;
    },
    afterNow(current) {
      return current && current > moment().startOf('day');
    },
    init(record) {
      this.$nextTick(() => {
        this.$refs.targetForm.resetFields();
        if (record) {
          this.form = Object.assign({}, record);
        } else {
          this.form = {};
        }
      })
    },
    beforeUpload(file) {
      let that = this;
      if (this.form.applicationId) {
        that.$message.error('已申请A码不能修改信息');
        return false;
      }
      if (!(file.type.includes("jpg") || file.type.includes("jpeg") || file.type.includes("png") || file.type.includes("bmp"))) {
        that.$message.error('只支持上传 jpg/jpeg/png/bmp 格式!');
        return false;
      }
      if (file.size / 1024 > 4000) {
        that.$message.error('证件文件大小必须小于 4M!');
        return false;
      }
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width < 2400 && img.height < 2400;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        return file;
      }, () => {
        that.$message.error('上传图片分辨率要小于2400*2400px!');
        return Promise.reject();
      });
      return isSize;
    },
    handlePassportChange(info) {
      if (info.file.status === 'uploading') {
        this.passportImg.loading = true;
        this.$set(this.form, 'passportImgUrl', '');
      }
      if (info.file.status === 'done') {
        this.passportImg.loading = false;
        let response = info.file.response;
        if (response.code === 200) {
          this.$set(this.form, 'passportImgUrl', response.data.url);
          this.$set(this.form, 'passportNumber', response.data.passport);
          this.$set(this.form, 'chineseName', response.data.chineseName);
          this.$set(this.form, 'surname', response.data.lastName);
          this.$set(this.form, 'givenName', response.data.firstName);
          this.$set(this.form, 'birthday', response.data.birth);
        }
      }
      if (info.file.status === 'error') {
        this.passportImg.loading = false;
      }
    },
    handleSubmit(openModel) {
      const that = this;
      this.$refs.targetForm.validate(valid => {
        if (valid) {
          if (!that.form.authority) {
            that.form.authority = localStorage.getItem('username');
          }
          that.$emit('emitBefore');
          const handleSuccess = (res) => {
            if (res) {
              let response = res.data;
              if (response.code === 200) {
                that.$emit('emitSuccess');
                if (openModel === 'modal') {
                  that.$refs.detailCreateModal.show(response.data.id, '继续完善', that);
                }
                if (openModel === 'link') {
                  let url = window._CONFIG['homeURL'] + "/#/usDsLink?timetamp=" + (new Date()).getTime() + "&id=" + response.data.id;
                  window.open(url, "_self")
                }
              } else {
                that.$message.error(response.msg);
              }
            }
          };
          that.$axios.post(that.url.add, that.form, {headers: that.headers})
              .then(handleSuccess)
              .catch((error) => that.catchError(error).then(handleSuccess))
              .finally(() => that.$emit('emitFinally'));
        }
      });
    },
    handleCancel() {
      this.form.passportImgUrl = null;
    },
    handleApplicationId() {
      const that = this;
      this.$refs.targetForm.validate(valid => {
        if (valid) {
          const handleSuccess = (res) => {
            if (res) {
              let response = res.data;
              if (response.code === 200) {
                that.$emit('emitApplicationId');
              } else {
                that.$message.error(response.msg);
              }
            }
          };
          that.$axios.put(that.url.addWithApplication, that.form, {headers: that.headers})
              .then(handleSuccess)
              .catch((error) => that.catchError(error).then(handleSuccess));
        }
      });
    },
  }
}

</script>

<style scoped>

</style>